import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { H1, P } from '../../../../components/Typography';
import Modal from '../../../../components/Modal';
import { ButtonGroup, Button } from '../../../../components/Buttons';
import { distances } from '../../../../styles/constants';

export interface ErrorModalProps {
    error?: any;
    onClose: () => void;
}

const safeJsonStringify = (value: any) => {
    try {
        return JSON.stringify(value, null, 2);
    } catch {
        return value;
    }
};

const ErrorModal = (
    {
        error,
        onClose,
    }: ErrorModalProps
) => {
    const { t } = useTranslation();
    if (!error) {
        return null;
    }
    return (
        <Modal fixedWidth>
            <H1>{t('customers.customer.attributes.error.title')}</H1>
            <P>{t('customers.customer.attributes.error.description')}</P>
            <Pre>{safeJsonStringify(error)}</Pre>
            <ButtonGroup>
                <Button className="alt" onClick={onClose}>
                    {t('customers.customer.attributes.error.close')}
                </Button>
            </ButtonGroup>
        </Modal>
    );
};

export default ErrorModal;

const Pre = styled.pre`
    color: #bd044b;
    padding: 0;
    padding-top: 2px;
    margin: 0;
    white-space: pre-wrap;
    margin-top: ${distances.small};
    margin-bottom: ${distances.normal};
`;
